const ManageBiography = {
  getBiographies: {
    url: "/admin/biography",
    method: "GET",
  },
  reportedBiographies: {
    url: "/reported-biography",
    method: "GET",
  },
  updateBiographyStatus: (memorialId) => ({
    url: `memorial/change-status/${memorialId}`,
    method: "PUT",
  }),
};
export default ManageBiography;
